// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { projectFulfillmentBySkuSchema } from '@/project/api/types';
import { z } from 'zod';

const projectFulfillmentBySkuResponseSchema = z.object({
  data: projectFulfillmentBySkuSchema,
  metadata: responseMetadataSchema,
});

type ProjectFulfillmentBySkuResponse = z.infer<
  typeof projectFulfillmentBySkuResponseSchema
>;

/**
 * Fetches the per-SKU fulfillment summary for a project. The backend does the
 * max-concurrent demand math and the FO aggregation in SQL — cancelled FOs are
 * excluded at query time so totals reflect coverage a project can actually
 * count on.
 */
export async function getProjectFulfillmentBySku(
  projectKey: string
): Promise<ProjectFulfillmentBySkuResponse> {
  const url = `/v1/project/${projectKey}/fulfillment-summary-by-sku`;
  const response = await api.get(url);
  return parseResponse(projectFulfillmentBySkuResponseSchema, response.data, {
    schemaName: 'ProjectFulfillmentBySku',
    endpoint: url,
  });
}
